import { App, Form, Input, Modal } from "antd";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";

interface RejectModalProps {
  open: boolean;
  onConfirm: (desc: string) => Promise<void>;
  onCancel: () => void;
  loading?: boolean;
}

const RejectModal: FC<RejectModalProps> = ({
  open,
  onConfirm,
  onCancel,
  loading = false
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setConfirmLoading(true);
      let rejectStr = values.desc ? t('requirement.rejectReason') + "：" + values.desc : ''
      await onConfirm(rejectStr);
      form.resetFields();
    } catch (error) {
      // 表单验证失败或 Promise 失败
    } finally {
      setConfirmLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={t('common.tip')}
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={t('common.confirm')}
      cancelText={t('common.cancel')}
      confirmLoading={confirmLoading || loading}
      destroyOnClose
    >
      <div style={{ marginBottom: 16 }}>
        {t('requirement.rejectTip')}
      </div>
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="desc"
          label={t('requirement.rejectReason')}
        >
          <Input.TextArea
            rows={4}
            placeholder={t('requirement.rejectReasonPlaceholder')}
            maxLength={500}
            showCount
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RejectModal;